export const CHECKLIST = 'CHECKLIST_CHECKLIST'
export const CHECKLIST_USER = 'CHECKLIST_USER'
export const CHECKLIST_MANAGER = 'CHECKLIST_MANAGER'
export const CHECKLIST_UPDATE = 'CHECKLIST_UPDATE'
export const CHECKLIST_SECTION_UPDATE = 'CHECKLIST_SECTION_UPDATE'
export const CHECKLIST_RESET = 'CHECKLIST_RESET'
export const CHECKLIST_RESET_DATA = 'CHECKLIST_RESET_DATA'
export const CHECKLIST_LOADED = 'CHECKLIST_LOADED'
export const SET_CERTIFY_TIME = 'SET_CERTIFY_TIME'
export const SET_REFERRED_FROM_MANAGER_REPORT =
	'SET_REFERRED_FROM_MANAGER_REPORT'
export const SET_CHECKLIST_APPROVAL = 'SET_CHECKLIST_APPROVAL'
export const CHECKLIST_APPROVE = 'CHECKLIST_APPROVE'
